import './two-columns.scss';

import enquire from 'enquire.js';
import { addScrollAnimation } from '../utils/scrollAnimation';
import { Responsive } from '../utils';

const COMPONENT_NAME = 'tcl-multistep';
// const EVENT_KEY = COMPONENT_NAME;
const BEM = {
  BLOCK: COMPONENT_NAME,
};

/**
 * version    1.0
 * class      <type> (two columns)
 * classdesc  Component that manage the page two colums
 */
export class TwoColumns {
  constructor() {
    this._findUIElements();

    enquire.register(`${Responsive.getBreakpointMaxMediaQuery('sm')}`, () => {
      const track = this._els.slider.find('.splide__track')[0];
      if (!track) return;
      addScrollAnimation(track, {
        offset: 50,
        minScale: 0.93,
        maxRadius: 20,
        forceFullWidth: true,
      });
    });
  }

  _findUIElements() {
    this._els = {
      multistep: $(`.${BEM.BLOCK}`),
      slider: $(`.${BEM.BLOCK}__slider`),
    };
  }
}
